<app-box-filter [index]="index" [label]="label" [individualFilter]="individualFilter">
  <div class="filter-stars" [class.filter-stars--adjust]="individualFilter">
    <ng-container *ngFor="let item of stars; index as starId; trackBy: trackById">
      <app-ds-chip-filter
        [size]="chipFilterSize"
        [options]="[
          {
            Label: item.Text,
            Icon: icons.Star,
            SpecialIcon: true,
          }
        ]"
        [state]="chipFilterState(itemIsSelected(item))"
        (clickEvent)="choiceItem(item)">
      </app-ds-chip-filter>
    </ng-container>
  </div>
</app-box-filter>
